import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var AccountPickerContainer = styled.div.withConfig({
  displayName: "AccountPicker__AccountPickerContainer",
  componentId: "sc-1mg764s-0"
})(["background-color:var(--wcds-account-picker-background-color);position:fixed;top:0;left:0;width:100%;height:100%;z-index:2000;transition:opacity 0.3s;opacity:1;iframe{width:100%;height:100%;border-width:0;}", ""], function (_ref) {
  var $isHidden = _ref.$isHidden;
  return $isHidden && css(["visibility:hidden;opacity:0;"]);
});

var AccountPicker = function AccountPicker(_ref2) {
  var onLoaded = _ref2.onLoaded,
      onSubmit = _ref2.onSubmit,
      onCancel = _ref2.onCancel,
      onError = _ref2.onError,
      isVisible = _ref2.isVisible;

  var onReceiveMessage = function onReceiveMessage(message) {
    if (message.origin === window.location.origin && !!message.data) {
      try {
        var data = JSON.parse(message.data);

        switch (data.type) {
          case 'account-picker/loaded':
            if (onLoaded) {
              var _data$payload, _data$payload2;

              onLoaded(data === null || data === void 0 ? void 0 : (_data$payload = data.payload) === null || _data$payload === void 0 ? void 0 : _data$payload.accountsIds, data === null || data === void 0 ? void 0 : (_data$payload2 = data.payload) === null || _data$payload2 === void 0 ? void 0 : _data$payload2.workspaceKey);
            }

            break;

          case 'account-picker/submit':
            if (onSubmit) {
              var _data$payload3, _data$payload4, _data$payload5;

              onSubmit(data === null || data === void 0 ? void 0 : (_data$payload3 = data.payload) === null || _data$payload3 === void 0 ? void 0 : _data$payload3.accountId, data === null || data === void 0 ? void 0 : (_data$payload4 = data.payload) === null || _data$payload4 === void 0 ? void 0 : _data$payload4.accountsListIndex, data === null || data === void 0 ? void 0 : (_data$payload5 = data.payload) === null || _data$payload5 === void 0 ? void 0 : _data$payload5.workspaceKey);
            }

            break;

          case 'account-picker/cancel':
            if (onCancel) {
              onCancel();
            }

            break;

          case 'account-picker/error':
            if (onError) {
              onError();
            }

            break;

          default:
            //do nothing
            break;
        }
      } catch (e) {//do nothing
      }
    }
  };

  useEffect(function () {
    window.addEventListener('message', onReceiveMessage, true);
    return function () {
      window.removeEventListener('message', onReceiveMessage);
    };
  }, []);
  var accountPickerUrl = "".concat(window.location.origin, "/app/account-picker/");
  return /*#__PURE__*/_jsx(AccountPickerContainer, {
    $isHidden: !isVisible,
    children: /*#__PURE__*/_jsx("iframe", {
      title: "Account picker",
      src: "".concat(accountPickerUrl, "?filterCanCreateBoard=1")
    })
  });
};

export default AccountPicker;